import jwt from './jwt'

const PARAM_KEY = 'token'

const insertParam = (query, key, value) =>
{
	key   = encodeURIComponent(key)
	value = encodeURIComponent(value)

	let piece = key + '=' + value
	let regex = new RegExp("(&|\\?)" + key + "=[^\&]*")

	query = query.replace(regex, "$1" + piece);

	if ( !RegExp.$1 )
	{
		query += ( ( query.length > 0 ) ? '&' : '?' ) + piece
	}

	return query
}

const compose = (value, base=window.location.origin) =>
{
	let token = jwt.getToken()

	if ( 'URL' in window )
	{
		let url = new URL(value, base)

		url.searchParams.set(PARAM_KEY, token)

		return url.href
	}

	return insertParam(path, 'token', token)
}

export default compose